import { createSelector } from 'reselect';

const selectComments = (state) => state.comments;

const selectCommentsData = createSelector(
	selectComments,
	(comments) => comments?.newComments
);

const selectCommentReply = createSelector(
	selectComments,
	(comments) => comments?.reply
);

const commentsSelector = {
	selectComments,
	selectCommentsData,
	selectCommentReply,
};

export default commentsSelector;
